import React, {Component} from 'react';
import {Col, Row, Tabs, Tab, FormControl} from 'react-bootstrap';
import config from  '../../../config';

import Select   from 'react-select'
import {} from "actions/actionTypes";
import {prepareSelectOptionsList, filterFocusAreaOptions,convertToHoursAndMinutes,  filterFocusAreaSelectedOptions} from 'util/Utils';

const allReportFieldList = [
    {label: 'Seller', value:'DisplayName'},
    {label: 'Seller Location', value:'MarketName'},
    {label: 'Inventory Balance (#)', value:'ProductsTotalNumber'},
    {label: 'Inventory Balance ($)', value:'ProductsTotalSum'},
    {label: 'Inventory Balance COGS ($)', value:'ProductsTotalCOGS'},
    {label: 'Sales in period (#)', value:'SaleTransactionsTotalNumber'},
    {label: 'Sales in period ($)', value:'SaleTransactionsTotalSum'},
    {label: 'Pending sales in period ($)', value:'PendingSaleTransactionsTotalSum'},
    {label: 'Pending COGs in period ($)', value:'PendingSaleTransactionsTotalProductCOGS'},
    {label: 'Sold COGs in period ($)', value:'SoldSaleTransactionsTotalProductCOGS'}

 ]

export default class AdminInventoryReconActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
            pending: false,
            BulkActionNote:'',
            selectedAction:'',
            displayTabs:{},
            reportFields: [
                {label: 'Seller', value:'DisplayName'},
                {label: 'Seller Location', value:'MarketName'},
                {label: 'Inventory Balance (#)', value:'ProductsTotalNumber'},
                {label: 'Inventory Balance ($)', value:'ProductsTotalSum'},
                {label: 'Inventory Balance COGS ($)', value:'ProductsTotalCOGS'},
                {label: 'Sales in period (#)', value:'SaleTransactionsTotalNumber'},
                {label: 'Sales in period ($)', value:'SaleTransactionsTotalSum'},
                {label: 'Pending sales in period ($)', value:'PendingSaleTransactionsTotalSum'},
                {label: 'Pending COGS in period ($)', value:'PendingSaleTransactionsTotalProductCOGS'},
                {label: 'Sold COGS in period ($)', value:'SoldSaleTransactionsTotalProductCOGS'}

            ]
         };

    };



    onSelectTab(event){
        this.setState({displayTabs:{...this.state.displayTabs,[event]:!this.state.displayTabs[event]}})
    }



    render() {
          return (
            <div className="transaction-action-block top20">
                <Tabs defaultActiveKey={'reports'}  onSelect={(e)=>{this.onSelectTab(e)}} id="userActionBox" >
                    <Tab eventKey={'reports'} unmountOnExit={true} title="Reports"
                      className= {_.get(this.state.displayTabs,['reports'], false) ? '':'hidden'}>
                    <Row className="show-grid">
                        <Col md={4} xs={4} className="top10">
                            <Select
                                tabIndex="0"
                                searchable={true}
                                multi
                                selectedOptions
                                clearable={false}
                                placeholder="Included fields"
                                options={allReportFieldList}
                                onChange={ (selectedOptions) => this.setState({reportFields: selectedOptions})}
                                //  filterOptions={filterOptions}
                                value={this.state.reportFields}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} xs={6} className="top10">
                            <button className="btn btn-primary" disabled={this.state.pending}
                                    onClick={ ()=>this.props.downloadReport({reportFields:this.state.reportFields})}
                                    type="button">
                                Download report
                            </button>
                        </Col>
                    </Row>
                    </Tab>

                </Tabs>
            </div>
        );

    }
}



